import { selectChangeMessageForStaticHtmlString } from '@newStore/documentUI/changeMessageSelectors/selectChangeMessageForStaticHtmlString';
import { selectParagraphNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { type BuildingBlockNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';
import { attachedContentComponent } from '@nodeTypeConfig/helpers/editComponents/attachedContent';
import { imageAlt, imageComponent } from '@nodeTypeConfig/helpers/editComponents/imageComponent';

const PARAGRAPH: BuildingBlockNodeConfig = {
  nodeSelector: selectParagraphNode,
  information: {
    single: 'Alinea',
    plural: "Alinea's",
    ribonIcon: require('../../../../img/buildingBlocks/PARAGRAPH.svg'),
  },

  createDefaults: {
    attachments: [
      {
        type: 'CONTENT',
        name: 'content.html',
        contentType: 'text/html',
      },
    ],
  },
  buildingBlocks: [],
  edit: [
    {
      ...attachedContentComponent,
      hideInAncestorTypes: [
        NodeType.PRONEWSLETTER,
        NodeType.LLINKID_CURRICULUM,
        NodeType.LLINKID_FOUNDATIONAL_CURRICULUM,
        NodeType.PRO_STATIC_PAGE,
        NodeType.WWW_STATIC_PAGE,
      ],
    },
    {
      ...attachedContentComponent,
      showInAncestorTypes: [NodeType.PRONEWSLETTER],
      options: {
        hideTermButton: true,
      },
    },
    {
      ...attachedContentComponent,
      showInAncestorTypes: [NodeType.LLINKID_CURRICULUM, NodeType.LLINKID_FOUNDATIONAL_CURRICULUM],
      options: {
        showMarkerButton: true,
      },
    },
    {
      component: 'staticHtml',
      reactComponent: 'AsideStaticHtml',
      label: 'Inhoud',
      property: '$$html',
      showInAncestorTypes: [NodeType.PRO_STATIC_PAGE, NodeType.WWW_STATIC_PAGE],
      asideChangeMessageSelector: selectChangeMessageForStaticHtmlString,
    },
    {
      ...imageComponent,
      options: {
        ...imageComponent.options,
        fields: imageAlt,
      },
      hideInAncestorTypes: [
        NodeType.LLINKID_STATIC_PART,
        NodeType.TERM,
        NodeType.PRONEWSLETTER,
        NodeType.PRONEWSLETTERTEMPLATE,
        NodeType.SUMMARY,
      ],
    },
  ],
  isCollapsible: false,
  onNewNodeDropped: {
    focusOnField: 'html',
  },
};

export default PARAGRAPH;
